/* global angular, moment */
/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.sv')
    .component('svnew', {
      restrict: 'E',
      bindings: {
      },
      template: `
      <div class="svnew-component" data-hook="svnew-component">
        <h3>Neue Sozialversicherung anlegen</h3>
        <div class="btn btn-success" ng-click="vm.addSv()" ng-hide="vm.newsv">Neue SV anlegen</div>
        <div ng-show="vm.newsv">
          <svform sv="vm.newsv" parentsave="vm.saveNewSv(sv)" oncancel="vm.cancel()"></svform>
        </div>
        <div ng-show="vm.created === true" class="alert alert-success spacer-top spacer-bottom">
          <h3><i class="fa fa-check"></i> Sozialversicherung erfolgreich angelegt!</h3>
        </div>
        <div ng-show="vm.canceled === true" class="alert alert-info spacer-top spacer-bottom">
          <h3><i class="fa fa-info"></i> Das Anlegen einer neuen Sozialversicherung wurde abgebrochen!</h3>
        </div>
        <div ng-show="vm.created === false" class="alert alert-danger spacer-top spacer-bottom">
          <h3>
            <i class="fa fa-warning"></i> Sozialversicherung konnte nicht angelegt werden,
            der Fehler wurde protokolliert!
            </h3>
        </div>
      </div>
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Sv', 'Rlog',
        function ($log, Sv, Rlog) {
          let vm = this;
          vm.addSv = addSv;
          vm.saveNewSv = saveNewSv;
          vm.cancel = cancel;

          function addSv() {
            vm.newsv = {};
            delete vm.created;
            delete vm.canceled;
          }
          
          function saveNewSv(sv) {
            $log.debug('debug: create new sv: ', sv);
            delete vm.newsv;
            Sv.$create(sv).$then(function () {
              vm.created = true;
            }, function (err) {
              vm.created = false;
              $log.error('Creation of new SV failed: ', err);
              Rlog.error('vcutils.sv', 'svnew', 'Creation of new SV failed: ', {error: err, sv: vm.newsv});
            });
          }
          
          function cancel() {
            delete vm.newsv;
            vm.canceled = true;
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
